import actionTypes from './actionTypes';
import { updateObject, createDeepCopy } from 'src/services/functions';
import { localAppointmentsFilters } from '../../services/appointments';
import { sortedList } from './actions';

const initialState = {
  list: [],
  unplannedList: [
    // {
    //   id: '2d33b436-5fec-4bb4-9cdf-2d2ea375c0cd',
    //   personId: 'c2cc5613-02a2-4d62-9532-117b72437bbe',
    //   practitionerId: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
    //   status: 'Waiting',
    //   createdDateTime: '2019-07-19T08:36:54.004517',
    //   patient: {
    //     firstName: 'Lagring',
    //     lastName: 'Karen',
    //     gender: 'Female',
    //     birthDate: '1985-07-27T00:00:00',
    //     status: 'Validated'
    //   }
    // }
  ],
  filters: {
    selectedAppointmentStatus: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_TODAY_APPOINTMENTS_SUCCESS: {
      const { list } = action.payload;
      return { ...state, list };
    }
    case actionTypes.LOAD_TODAY_APPOINTMENTS_ERROR:
      return { ...state, list: [] };
    case actionTypes.PATIENT_ARRIVED_ERROR:
      return { ...state };
    case actionTypes.CLEAR_LIST:
      return { ...state, list: [] };

    //──── Single appointment ────────────────────────────────────────────────────────────────
    case actionTypes.RESET_SINGLE_APPOINTMENT_IN_LIST: {
      let tempList = createDeepCopy(state.list);
      // if exist we just updated it
      if (tempList.find(el => el.id === action.payload.appointmentId)) {
        tempList = tempList.map(item => {
          if (item.id === action.payload.appointmentId) {
            return action.payload.newAppointment;
          }
          return item;
        });
      } else {
        // if we don't hawe this item just added it
        tempList.push(action.payload.newAppointment);
        tempList = sortedList(tempList);
      }

      return {
        ...state,
        list: tempList
      };
    }
    case actionTypes.UPDATE_SINGLE_APPOINTMENT_IN_LIST: {
      const tempList = createDeepCopy(state.list).map(item => {
        if (item.id === action.payload.appointmentId) {
          return updateObject(item, action.payload.dataObj);
        }
        return item;
      });
      return {
        ...state,
        list: tempList
      };
    }
    //──── Filters ───────────────────────────────────────────────────────────────────────────
    // Statuses
    case actionTypes.SET_FILTER_APPOINTMENT_STATUSES: {
      if (action.payload && action.payload instanceof Array) {
        const tFilters = createDeepCopy(state.filters);
        tFilters.selectedAppointmentStatus = action.payload.map(filter => String(filter));
        return { ...state, filters: tFilters };
      }
      return state;
    }
    case actionTypes.UPDATE_FILTER_APPOINTMENT_STATUS: {
      const tFilters = createDeepCopy(state.filters);
      const statusList = tFilters.selectedAppointmentStatus || [];
      const index = statusList.findIndex(_el => String(_el) === String(action.payload));
      if (index > -1) {
        statusList.splice(index, 1);
      } else {
        statusList.push(String(action.payload));
      }
      localAppointmentsFilters.set({ selectedAppointmentStatus: statusList });
      tFilters.selectedAppointmentStatus = statusList;
      return { ...state, filters: tFilters };
    }

    // Reset
    case actionTypes.RESET_APPOINTMENTS_FILTERS: {
      const _tFilters = Object.assign({}, initialState.filters);
      return { ...state, filters: _tFilters };
    }

    //──── Unplanned ─────────────────────────────────────────────────────────────────────────
    case actionTypes.SET_UNPLANNED_APPOINTMENTS: {
      return {
        ...state,
        unplannedList: action.payload
      };
    }
    case actionTypes.REMOVE_UNPLANNED_APPOINTMENT_BY_ID: {
      const filterList = state.unplannedList.filter(el => el.id !== action.payload);
      return {
        ...state,
        unplannedList: filterList
      };
    }

    default:
      return state;
  }
};
